import BybAnimatedBorder from "@Components/common/byb-ds/byb-animated-border";
import Icon from "@Components/generic/icon";
import KeyboardKeys from "@Enums/KeyboardKeys";
import useI18n from "@i18n";
import { Alert, Box, Snackbar, Typography, useTheme } from "@mui/material";
import { KeyboardEvent } from "react";

interface ITrainingFocusSnackbar {
  open: boolean;
  navBarHeight: number;
  onNavigateToSection: () => void;
}

export const TrainingFocusSnackbar = ({ open, navBarHeight, onNavigateToSection }: ITrainingFocusSnackbar) => {
  const { i18n } = useI18n();
  const theme = useTheme();

  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key !== KeyboardKeys.ENTER && event.key !== KeyboardKeys.SPACE) {
      return;
    }

    event.preventDefault();
    onNavigateToSection();
  };

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      sx={{
        "&.MuiSnackbar-root": { top: `calc(${navBarHeight}px + ${theme.spacing(2)})` },
      }}
    >
      <Box>
        <BybAnimatedBorder borderRadius={theme.spacing(4)} color={theme.palette.dsYellow?.v300} sx={{ cornerShape: "squircle" }}>
          <Alert
            icon={<Icon dsIcon="osiris" size={24} color="vrYellow.v300" />}
            severity="info"
            role="button"
            tabIndex={0}
            aria-label={i18n("progress.training-focus.snackbar")}
            onClick={onNavigateToSection}
            onKeyDown={handleKeyDown}
            sx={{ borderRadius: theme.spacing(4), cursor: "pointer" }}
          >
            <Typography variant="textBase600" color="dsBase.v200">
              {i18n("progress.training-focus.snackbar")}
            </Typography>
          </Alert>
        </BybAnimatedBorder>
      </Box>
    </Snackbar>
  );
};
